/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками кодов доступа
 */

/**
 * Сервис управления настройками кодов доступа
 */
export class CodeServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод удаления одного кода доступа
   */
  DeleteCode = (req: DeleteCodeRequestDto, init?: RequestInit): Promise<DeleteCodeResponseDto> => {
    return fm.request<DeleteCodeRequestDto, DeleteCodeResponseDto>(`${this.host}/device/api/v1/code/${encodeURIComponent(req.code)}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления списка кодов доступа
   */
  DeleteCodeList = (req?: DeleteCodeListRequestDto, init?: RequestInit): Promise<DeleteCodeListResponseDto> => {
    return fm.request<DeleteCodeListRequestDto, DeleteCodeListResponseDto>(`${this.host}/device/api/v1/code/list`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения кода доступа
   */
  GetCode = (req: GetCodeRequestDto, init?: RequestInit): Promise<GetCodeResponseDto> => {
    return fm.request<GetCodeRequestDto, GetCodeResponseDto>(`${this.host}/device/api/v1/code/${encodeURIComponent(req.code)}${fm.buildQuery(req, ["code"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения количества кодов доступа
   */
  GetCodeCount = (req?: GetCodeCountRequestDto, init?: RequestInit): Promise<GetCodeCountResponseDto> => {
    return fm.request<GetCodeCountRequestDto, GetCodeCountResponseDto>(`${this.host}/device/api/v1/code/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка кодов доступа
   */
  GetCodeList = (req?: GetCodeListRequestDto, init?: RequestInit): Promise<GetCodeListResponseDto> => {
    return fm.request<GetCodeListRequestDto, GetCodeListResponseDto>(`${this.host}/device/api/v1/code/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания кода доступа
   */
  SaveCode = (req: SaveCodeRequestDto, init?: RequestInit): Promise<SaveCodeResponseDto> => {
    return fm.request<SaveCodeRequestDto, SaveCodeResponseDto>(`${this.host}/device/api/v1/code`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания списка кодов доступа
   */
  SaveCodeList = (req?: SaveCodeListRequestDto, init?: RequestInit): Promise<SaveCodeListResponseDto> => {
    return fm.request<SaveCodeListRequestDto, SaveCodeListResponseDto>(`${this.host}/device/api/v1/code/list`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Код доступа
 */
export type CodeRequestDto = {
  /**
   * Код доступа
   */
  code: string
  /**
   * Описание
   */
  description?: string
  /**
   * Идентификаторы реле.
   * Диапазон: 1..64
   */
  relayIndexes?: number[]
}
/**
 * Код доступа
 */
export type CodeResponseDto = {
  /**
   * Код доступа
   */
  code: string
  /**
   * Описание
   */
  description: string
  /**
   * Идентификаторы реле.
   * Диапазон: 1..64
   */
  relayIndexes: number[]
}
/**
 * Ошибки сохранения
 */
export type CodeSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Реле не найдено
   */
  readonly relayNotFound: CodeSavingErrorRelayNotFoundRequestDto
}>
/**
 * Ошибки сохранения
 */
export type CodeSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Реле не найдено
   */
  readonly relayNotFound: CodeSavingErrorRelayNotFoundResponseDto
}>
/**
 * Реле не найдено
 */
export type CodeSavingErrorRelayNotFoundRequestDto = {
}
/**
 * Реле не найдено
 */
export type CodeSavingErrorRelayNotFoundResponseDto = {
}
/**
 * Постраничный вывод
 */
export type CodePagingRequestDto = {
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type CodePagingResponseDto = {
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос удаления списка кодов доступа
 */
export type DeleteCodeListRequestDto = {
}
/**
 * Ответ на запрос удаления списка кодов доступа
 */
export type DeleteCodeListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего количество удаленных
   */
  readonly data: number
}>
/**
 * Запрос удаления одного кода доступа
 */
export type DeleteCodeRequestDto = {
  /**
   * Код доступа
   */
  code: string
}
/**
 * Ответ на запрос удаления одного кода доступа
 */
export type DeleteCodeResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteCodeResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type DeleteCodeResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type DeleteCodeResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения количества кодов доступа
 */
export type GetCodeCountRequestDto = {
}
/**
 * Ответ на запрос получения количества кодов доступа
 */
export type GetCodeCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего количество
   */
  readonly data: number
}>
/**
 * Запрос получения списка кодов доступа
 */
export type GetCodeListRequestDto = {
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Постраничный вывод
   */
  readonly paging: CodePagingRequestDto
}>
/**
 * Ответ на запрос получения списка кодов доступа
 */
export type GetCodeListResponseDto = {
  /**
   * Список Code
   */
  data: CodeResponseDto[]
}
/**
 * Запрос получения получения кода доступа
 */
export type GetCodeRequestDto = {
  /**
   * Код доступа
   */
  code: string
}
/**
 * Ответ на запрос получения получения кода доступа
 */
export type GetCodeResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Код доступа
   */
  readonly data: CodeResponseDto
}>
/**
 * Запрос на создание списка кодов доступа
 */
export type SaveCodeListRequestDto = {
  /**
   * Список Code
   */
  data?: CodeRequestDto[]
}
/**
 * Ответ на создание списка кодов доступа
 */
export type SaveCodeListResponseDto = {
  /**
   * Список Code
   */
  data: CodeResponseDto[]
  /**
   * Список ошибок
   */
  errors: SaveCodeListResponseErrorDto[]
}
/**
 * Ошибка запроса
 */
export type SaveCodeListResponseErrorRequestDto = {
  /**
   * Код доступа
   */
  code: string
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: CodeSavingErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type SaveCodeListResponseErrorDto = {
  /**
   * Код доступа
   */
  code: string
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: CodeSavingErrorResponseDto
}>
/**
 * Запрос создания кода доступа
 */
export type SaveCodeRequestDto = {
  /**
   * Код доступа
   */
  data: CodeRequestDto
}
/**
 * Ответ на запрос создания кода доступа
 */
export type SaveCodeResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Код доступа
   */
  readonly data: CodeResponseDto
  /**
   * Ошибка
   */
  readonly error: SaveCodeResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type SaveCodeResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: CodeSavingErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type SaveCodeResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: CodeSavingErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Код доступа
   */
  "Code": {
    "kind": "class",
    "text": "Код доступа",
    "fields": {
      /**
       * Код доступа
       */
      "code": {
        "type": "string",
        "text": "Код доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Описание
       */
      "description": {
        "type": "string",
        "text": "Описание",
      },
      /**
       * Идентификаторы реле.
       * Диапазон: 1..64
       */
      "relayIndexes": {
        "type": "int32",
        "text": "Идентификаторы реле.\nДиапазон: 1..64",
      },
    },
  },
  /**
   * Ошибки сохранения
   */
  "Code.SavingError": {
    "kind": "class",
    "text": "Ошибки сохранения",
    "fields": {
      /**
       * Реле не найдено
       */
      "relayNotFound": {
        "type": "Code.SavingError.RelayNotFound",
        "text": "Реле не найдено",
      },
    },
  },
  /**
   * Реле не найдено
   */
  "Code.SavingError.RelayNotFound": {
    "kind": "class",
    "text": "Реле не найдено",
  },
  /**
   * Постраничный вывод
   */
  "CodePaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос удаления списка кодов доступа
   */
  "DeleteCodeListRequest": {
    "kind": "class",
    "text": "Запрос удаления списка кодов доступа",
  },
  /**
   * Ответ на запрос удаления списка кодов доступа
   */
  "DeleteCodeListResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления списка кодов доступа",
    "fields": {
      /**
       * Всего количество удаленных
       */
      "data": {
        "type": "int32",
        "text": "Всего количество удаленных",
      },
    },
  },
  /**
   * Запрос удаления одного кода доступа
   */
  "DeleteCodeRequest": {
    "kind": "class",
    "text": "Запрос удаления одного кода доступа",
    "fields": {
      /**
       * Код доступа
       */
      "code": {
        "type": "string",
        "text": "Код доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления одного кода доступа
   */
  "DeleteCodeResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления одного кода доступа",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteCodeResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "DeleteCodeResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества кодов доступа
   */
  "GetCodeCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества кодов доступа",
  },
  /**
   * Ответ на запрос получения количества кодов доступа
   */
  "GetCodeCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества кодов доступа",
    "fields": {
      /**
       * Всего количество
       */
      "data": {
        "type": "int32",
        "text": "Всего количество",
      },
    },
  },
  /**
   * Запрос получения списка кодов доступа
   */
  "GetCodeListRequest": {
    "kind": "class",
    "text": "Запрос получения списка кодов доступа",
    "fields": {
      /**
       * Постраничный вывод
       */
      "paging": {
        "type": "CodePaging",
        "text": "Постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос получения списка кодов доступа
   */
  "GetCodeListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка кодов доступа",
    "fields": {
      /**
       * Список Code
       */
      "data": {
        "type": "Code",
        "text": "Список Code",
      },
    },
  },
  /**
   * Запрос получения получения кода доступа
   */
  "GetCodeRequest": {
    "kind": "class",
    "text": "Запрос получения получения кода доступа",
    "fields": {
      /**
       * Код доступа
       */
      "code": {
        "type": "string",
        "text": "Код доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения получения кода доступа
   */
  "GetCodeResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения получения кода доступа",
    "fields": {
      /**
       * Код доступа
       */
      "data": {
        "type": "Code",
        "text": "Код доступа",
      },
    },
  },
  /**
   * Запрос на создание списка кодов доступа
   */
  "SaveCodeListRequest": {
    "kind": "class",
    "text": "Запрос на создание списка кодов доступа",
    "fields": {
      /**
       * Список Code
       */
      "data": {
        "type": "Code",
        "text": "Список Code",
      },
    },
  },
  /**
   * Ответ на создание списка кодов доступа
   */
  "SaveCodeListResponse": {
    "kind": "class",
    "text": "Ответ на создание списка кодов доступа",
    "fields": {
      /**
       * Список Code
       */
      "data": {
        "type": "Code",
        "text": "Список Code",
      },
      /**
       * Список ошибок
       */
      "errors": {
        "type": "SaveCodeListResponse.Error",
        "text": "Список ошибок",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "SaveCodeListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Код доступа
       */
      "code": {
        "type": "string",
        "text": "Код доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "Code.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Запрос создания кода доступа
   */
  "SaveCodeRequest": {
    "kind": "class",
    "text": "Запрос создания кода доступа",
    "fields": {
      /**
       * Код доступа
       */
      "data": {
        "type": "Code",
        "text": "Код доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос создания кода доступа
   */
  "SaveCodeResponse": {
    "kind": "class",
    "text": "Ответ на запрос создания кода доступа",
    "fields": {
      /**
       * Код доступа
       */
      "data": {
        "type": "Code",
        "text": "Код доступа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "SaveCodeResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "SaveCodeResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "Code.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
}